const RELOAD_TIMESTAMP_KEY = 'chunk-error-reload-at';
const RELOAD_DEBOUNCE_MS = 10_000;

const CHUNK_ERROR_PATTERNS = [
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'Importing a module script failed',
  'ChunkLoadError',
];

export const isChunkLoadError = (error: unknown): boolean => {
  if (!error) return false;
  const message = error instanceof Error ? error.message : String(error);
  const name = error instanceof Error ? error.name : '';
  return (
    name === 'ChunkLoadError' ||
    CHUNK_ERROR_PATTERNS.some((pattern) => message.includes(pattern))
  );
};

// Reload once on chunk-load error; bail out if we just reloaded so we don't loop
// when the chunk is genuinely missing rather than just stale.
export const reloadForStaleChunk = (): boolean => {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_TIMESTAMP_KEY) ?? 0);
    if (Date.now() - last < RELOAD_DEBOUNCE_MS) {
      return false;
    }
    sessionStorage.setItem(RELOAD_TIMESTAMP_KEY, String(Date.now()));
    window.location.reload();
    return true;
  } catch {
    return false;
  }
};
